<template>
  <v-row>
    <v-dialog v-model.sync="ticketsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>        
        <v-toolbar fixed>
          <v-btn icon @click="$store.dispatch('setTicketsDialog', false)">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Etiquetas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="print" fixed right fab dark color="indigo">
            <v-icon dark>print</v-icon>
          </v-btn>
        </v-toolbar>
        <div id="pdfTickets" ref="pdfTicket">
          <v-row>
            <v-col
              xs="6"
              md="4"
              v-for="t in transactions"
              :key="t.id"
            >
            <p><strong>Destinário</strong></p>
            Nome: {{t.customer.name}}<br/>
            Endereço: {{
              t.customer.address && t.customer.address.address
            }}, {{
              t.customer.address && t.customer.address.number            
            }}<br/>
            Complemento: {{
              t.customer.address && (t.customer.address.complement ? t.customer.address.complement : '-')
            }}<br/>
            Bairro: {{
              t.customer.address && t.customer.address.district
            }}<br/>
            Cidade: {{
              t.customer.address && t.customer.address.city.name
            }}/{{
              t.customer.address && t.customer.address.city.state.abbr
            }}<br/>
            CEP: {{
              t.customer.address && t.customer.address.postal_code
            }}<br/><br/>
            Loja: {{t.store.name}}<br/>
            quantidade: {{t.plan ? t.plan.qnt * t.qnt : t.qnt}}<br/>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    data () {
      return {  
      }
    },
    methods: {
      print() {
        if (window) {
          const divContents = document.getElementById('pdfTickets').innerHTML;
          const params = [
              'height='+screen.height,
              'width='+screen.width,
              'fullscreen=yes' // only works in IE, but here for completeness
          ].join(',');
          var printWindow = window.open('', '', params);
          printWindow.document.write('<html><head></head><body><style>body,html{   margin: 0;  padding: 0;   font-size: 14pt; } * {  box-sizing: border-box; } body > div > div {    page-break-inside: avoid;   word-wrap: break-word;  /* float: left;  */   display: inline-block;  /* min-height: 100mm; */  width: 48%; } @media print {    body > div > div {        page-break-inside: avoid;       word-wrap: break-word;    /* float: left;  */     display: inline-block;    /* min-height: 100mm; */    width: 48%;   } } body > div > div:nth-child(even) {  margin-left: 4%; }</style>');                
          printWindow.document.write(divContents);
          printWindow.document.write('</body></html>');
          printWindow.document.close();
          const time_hndlr = setTimeout(() => {
            printWindow.print();
            clearTimeout(time_hndlr);
          }, 1500);
        }
      }
    },
    computed: {
      ticketsDialog: {
        get() {
          return this.$store.state.ticketsDialog;
        },
        set(value) {          
          this.$store.commit('setTicketsDialog', value);
        }
      },
      transactions () {
        return this.$store.state.transactions.data.filter(t => t.customer.address && true);
      }
    }
  }
</script>
